import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Card, Alert, InputGroup } from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../context/MenuProvider';

const PushAdmin = () => {
  const { id } = useParams();
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const [prospectos, setProspectos] = useState([]);
  const [apn, setApn] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const {
    crud,
    auth,
    salvarDados,
    setLinks,
    setBtns,
    SERVER_BASE_URL,
  } = useProvider();
  const { post, del, patch, put, get, loading } = crud || {};

  const location = useLocation();

  useEffect(() => {
    setApn((item) => ({
      ...item,
      data:new Date().toLocaleDateString('sv-SE'),
    }))
  }, [id]);

  

  useEffect(() => {
    setLinks([]);
    setBtns([
      ...(id ?[{
        icon: 'bi-trash',
        onClick: async (e) => {
          e?.preventDefault();
          await handleDelete();
        },
      }]:[]),
      {
        icon: 'bi-check-lg',
        onClick: async (e) => {
          e?.preventDefault();
          await handleSubmit();
        },
      },
    ]);

    return () => {
      setLinks([]);
      setBtns([]);
    };
  }, [setLinks, setBtns, apn]);


  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const errors = {};
    // if (!apn?.nome || apn.nome === '') errors.nome = 'Por favor, informe o nome do apn.';
    // if (!apn?.data || apn.data === '') errors.data = 'Por favor, informe a data da apresentação.';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    // setFormErrors({});

    // const formData = new FormData();
    // formData.append('nome', apn?.nome);
    // formData.append('data', apn?.data);
    // formData.append('upline', apn?.upline?.id || parseInt(apn?.upline) || ``);
    // formData.append('prospecto', apn?.prospecto?.id || parseInt(apn?.prospecto) || ``);
    // formData.append('observacoes', apn?.observacoes || ``);

    
    // if(!id){
    //   Swal.fire({
    //     title: "Fez pré cadastro?",
    //     text: `${apn?.prospecto?.contato?.nome_do_cliente || apn?.prospecto?.nome || apn?.nome} fez o pré cadastro?`,
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Sim!",
    //     cancelButtonText: "Não"
    //   }).then(async(result) => {
    //     formData.append('pre_cadastro', !!result.isConfirmed);
    //     await salvarApn(formData);
    //   });
    // } else {
    //     formData.append('pre_cadastro', !!apn?.pre_cadastro);
    //     await salvarApn(formData);
    // } 

    await salvarApn({
      title: 'Nova Notificação',
      body:apn?.observacoes || 'Você tem uma nova mensagem!',
      icon: '/images/icon-192x192.png',
      badge: '/images/teste.png',
      data: { url: '/' },
      customData: { userId: 1123, userName: 'Francosco Teste' },
    });
  };
  
  const handleDelete = async (e) => {
    if (e) e.preventDefault();
    
    Swal.fire({
        title: "Excluir APN?",
        text: `Excluir definitivamente a APN realizada com ${apn?.prospecto?.contato?.nome_do_cliente || apn?.prospecto?.nome || apn?.nome}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
    }).then(async(result) => {
        if(result.isConfirmed){
          try{
            await del(`/rede/apn/${id}/`);
            Toast.fire({
              icon: 'success',
              title: 'APN excluída com sucesso',
            });
            navigate(-1);
          }catch(err){
            Toast.fire({
              icon: 'warning',
              title: 'Falha ao excluir APN',
            });
          }finally{
            
          }
        }
    });
  };
  
  useEffect(() => {
    // roda imediatamente
    if (qrCode?.status !== 'conectado') {
      conectarWhatsApp();
    }
  
    // roda a cada 20 segundos
    const interval = setInterval(() => {
      if (qrCode?.status !== 'conectado') {
        conectarWhatsApp();
      }
    }, 20000);
  
    return () => clearInterval(interval);
  }, [qrCode?.status]);
  
  const salvarApn = async (formData) => {
    try {
      const apiRequest = id ? patch : post;
      const response = await post(
        formData,
        `${SERVER_BASE_URL}/push/send/`,
      );

      if (response && response.length) {
        Toast.fire({
          icon: 'success',
          title: 'Consultor salvo com sucesso',
        });
      }
    } catch (err) {
      const errorMessage =
        typeof err.response?.data === 'string'
          ? 'Erro ao salvar o cliente.'
          : err.response?.data?.detail;

      setFormErrors(prev => ({
        ...prev,
        apiError: errorMessage,
        telefone: err.response?.data?.telefone,
        documento: err.response?.data?.cpf_cnpj,
        nome: err.response?.data?.nome,
        data: err.response?.data?.data,
        endereco: err.response?.data?.endereco,
        diaDoAniversario: err.response?.data?.dia_do_aniversario,
        ativo: err.response?.data?.ativo,
        observacoes: err.response?.data?.observacoes,
        crediario: err.response?.data?.crediario,
        regiao: err.response?.data?.regiao,
      }));
    }
  }
  const conectarWhatsApp = async (tentativa = 0) => {
    try {
      const response = await get(`${SERVER_BASE_URL}/whatsapp/qrcode/`);
  
      if (response && response.length) {
        setQrCode(response[0]);
      }
    } catch (err) {
      // verifica se foi timeout
      const isTimeout = err.code === 'ECONNABORTED' || err.message?.includes('timeout');
      if (isTimeout && tentativa < 5) {
        // tenta novamente após 2 segundos
        setTimeout(() => conectarWhatsApp(tentativa + 1), 2000);
      } else {
        const errorMessage =
          typeof err.response?.data === 'string'
            ? 'Erro ao salvar o cliente.'
            : err.response?.data?.detail;
  
        setFormErrors(prev => ({
          ...prev,
          apiError: errorMessage,
          telefone: err.response?.data?.telefone,
          documento: err.response?.data?.cpf_cnpj,
          nome: err.response?.data?.nome,
          data: err.response?.data?.data,
          endereco: err.response?.data?.endereco,
          diaDoAniversario: err.response?.data?.dia_do_aniversario,
          ativo: err.response?.data?.ativo,
          observacoes: err.response?.data?.observacoes,
          crediario: err.response?.data?.crediario,
          regiao: err.response?.data?.regiao,
        }));
      }
    }
  };
  
  const enviarWhatsApp = async () => {
    //alert(JSON.stringify(auth.url))
    try {
      const apiRequest = id ? patch : post;
      const response = await post(
        {
          "tipo": apn?.tipo || null,
          "mensagem": apn?.observacoes || `Mensagem de teste`,
          "telefone": "69992839969",
          "contato": 3149
        },
        `/core/mensagens-whatsapp/`,
      );

      if (response && response.length) {
        Toast.fire({
          icon: 'success',
          title: 'Mensagem enviada com sucesso',
        });
        alert(JSON.stringify(response))
      }
    } catch (err) {
      alert(JSON.stringify(err))
      alert(JSON.stringify(err.response))
      const errorMessage =
        typeof err.response?.data === 'string'
          ? 'Erro ao enviar mensagem.'
          : err.response?.data?.message || err.response?.data?.detail;

      setFormErrors(prev => ({
        ...prev,
        apiError: errorMessage,
        telefone: err.response?.data?.telefone,
        documento: err.response?.data?.cpf_cnpj,
        nome: err.response?.data?.nome,
        data: err.response?.data?.data,
        endereco: err.response?.data?.endereco,
        diaDoAniversario: err.response?.data?.dia_do_aniversario,
        ativo: err.response?.data?.ativo,
        observacoes: err.response?.data?.observacoes,
        crediario: err.response?.data?.crediario,
        regiao: err.response?.data?.regiao,
      }));
    }
  }
  
  const carregarMais = () => {
    setApn((prev) => ({
      ...prev,
      upline:null
    }))
  }

  return (<>
    <Row>
      <Col md={6} lg={4} className="mx-auto">
        <div className="d-flex justify-content-center">
          <img src={qrCode?.qr} className="img-fluid" />
        </div>
        <div className="fs-4 text-center">
          {qrCode?.status === "conectado" && (<>
            WhatsApp Conectado {qrCode.numero}
          </>)}
          {qrCode?.status === "aguardando_qr" && (<>
            Escaneie o QR Code para conectar com o WhatsApp
          </>)}
          {qrCode?.status === "desconectado" && (<>
            WhatsApp Desconectado
          </>)}
        </div>
        <Card className="d-none">
          <Card.Body>
            {!qrCode?.qr && (<>
              <Form onSubmit={handleSubmit}>
                {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                <Form.Group controlId="formDataCadastro" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Data</span>
                    <Form.Control
                      type="date"
                      value={apn?.data || ''}
                      onChange={(e) =>
                        setApn((item) => ({
                          ...item,
                          data: e.target.value,
                        }))
                      }
                    />
                  </InputGroup>
                  {formErrors.data && <Alert variant="danger">{formErrors.data}</Alert>}
                </Form.Group>
                <Form.Group controlId="formTipo" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Tipo</span>
                    <Form.Control
                      type="text"
                      value={apn?.tipo || ''}
                      onChange={(e) =>
                        setApn((item) => ({
                          ...item,
                          tipo: e.target.value,
                        }))
                      }
                    />
                  </InputGroup>
                  {formErrors.tipo && <Alert variant="danger">{formErrors.tipo}</Alert>}
                </Form.Group>
                <Form.Group controlId="formObservacoes" className="mt-3">
                  <Form.Control
                    as="textarea"
                    value={apn?.observacoes}
                    onChange={(e) => setApn((prev)=> ({
                      ...prev,
                      observacoes:e.target.value
                    }))}
                    placeholder="Observações"
                    rows={5}
                    style={{ resize: 'none' }}
                  />
                </Form.Group>
                <Button variant="secondary" type="submit" className="mt-4 w-100" disabled={loading}>
                  Enviar
                </Button>
              </Form>
              <Button variant="secondary" onClick={enviarWhatsApp} className="mt-4 w-100" disabled={loading}>
                  Enviar Whatsapp
              </Button>
            </>)}
            {qrCode?.qr && (<>
              <div className="fs-4 text-center">Conectar com WhatsApp</div>
            </>)}
            <Button variant="secondary" onClick={conectarWhatsApp} className="mt-4 w-100" disabled={loading}>
                Conectar WhatsApp
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </>
  );
};

export default PushAdmin;